import React, { useCallback, useMemo } from 'react';
import { Typography } from '@mui/material';
import { AdminMenu } from '@client/new/components/AdminMenu/AdminMenu';
import { useUser } from '@client/new/hooks/use-user';
import { browserHistory } from 'react-router';
import { clsx } from 'clsx';
import { PATHS } from '@client/routes';
import auth from '@client/components/auth';
import {
  adminContext,
  creatorContext,
  main,
  navigation,
  navigationAdminContext,
  page,
} from './AdminLayout.css';

const getAdminContext = (pathname: string) => {
  const isOnAdminPage = [
    PATHS.HOME,
    PATHS.CONFIG_FILE,
    PATHS.ANALYTICS,
    PATHS.PORTAL_USERS,
    PATHS.ADMIN_NEW_CREATOR,
    PATHS.STRIPE_CALLBACK,
  ]
    .map((i) => `/${pathname}`.endsWith(i))
    .some((i) => i);
  const isOnAdminSubPage = [PATHS.PORTAL_USERS]
    .map((i) => `/${pathname}`.includes(i))
    .some((i) => i);
  return isOnAdminPage || isOnAdminSubPage;
};

export const AdminLayout = ({
  children,
  heading,
  pathname,
}: {
  children: React.ReactNode;
  heading?: React.ReactNode;
  pathname: string;
}) => {
  const { logout: logoutUser } = useUser();

  const isAdminContext = useMemo(() => getAdminContext(pathname), [pathname]);
  const customPermissions = auth.getCustomPermissions();

  const logout = useCallback(() => {
    auth.logout();
    logoutUser();
    browserHistory.push('/login');
  }, []);

  return (
    <div className={page}>
      <div
        className={clsx(navigation, isAdminContext && navigationAdminContext)}
      >
        <AdminMenu
          isAdminContext={isAdminContext}
          logout={logout}
          customPermissions={customPermissions}
        />
      </div>
      <main
        className={clsx(
          main,
          isAdminContext && adminContext,
          !isAdminContext && creatorContext,
        )}
      >
        {heading && <Typography variant="h1">{heading}</Typography>}
        {children}
      </main>
    </div>
  );
};
